// Generated by ReScript, PLEASE EDIT WITH CARE
'use strict';

var React = require("react");
var FormV5 = require("../Form/FormV5.bs.js");
var View__Jsx3 = require("../../helpers/View__Jsx3.bs.js");
var Caml_option = require("rescript/lib/js/caml_option.js");
var Form__Label = require("../Form/Form__Label.bs.js");
var Core__Option = require("@rescript/core/src/Core__Option.bs.js");
var JsxRuntime = require("react/jsx-runtime");
var Colors = require("uikit/styles/colors");
var ReactStripeJs = require("@stripe/react-stripe-js");

function MakeStripeElement(StripeElement) {
  var stripeErrorFromJs = function (s) {
    switch (s) {
      case "incomplete_cvc" :
          return "IncompleteCVC";
      case "incomplete_expiry" :
          return "IncompleteExpiry";
      case "incomplete_number" :
          return "IncompleteCardNumber";
      case "invalid_expiry_month_past" :
          return "ExpiryMonthPast";
      case "invalid_expiry_year" :
          return "InvalidExpiryYear";
      case "invalid_expiry_year_past" :
          return "ExpiryYearPast";
      case "invalid_number" :
          return "InvalidCardNumber";
      default:
        return ;
    }
  };
  var elementsStyle = {
    base: {
      fontSize: "14px",
      fontWeight: "400",
      color: Colors.black
    },
    complete: {
      color: Colors.black
    },
    invalid: {
      color: Colors.black
    }
  };
  var wrapperStyle = function (focused, inputState) {
    var tmp;
    if (focused) {
      tmp = Colors.goldTips;
    } else if (typeof inputState !== "object") {
      switch (inputState) {
        case "Empty" :
        case "InProgress" :
            tmp = Colors.alto;
            break;
        case "Complete" :
            tmp = Colors.chelseaCucumber;
            break;
        
      }
    } else {
      tmp = Colors.crimson;
    }
    return {
            borderColor: tmp,
            borderStyle: "solid",
            borderWidth: "1px",
            padding: "10px 14px",
            transition: "150ms"
          };
  };
  var Stripe__Components$MakeStripeElement = function (props) {
    var onValidationChange = props.onValidationChange;
    var labelText = props.labelText;
    var match = React.useReducer((function (state, action) {
            if (action.TAG === "SetInputState") {
              return {
                      inputState: action._0,
                      focused: state.focused
                    };
            } else {
              return {
                      inputState: state.inputState,
                      focused: action._0
                    };
            }
          }), {
          inputState: "Empty",
          focused: false
        });
    var dispatch = match[1];
    var match$1 = match[0];
    var inputState = match$1.inputState;
    React.useEffect((function () {
            if (onValidationChange !== undefined) {
              if (typeof inputState !== "object" && inputState === "Complete") {
                onValidationChange(true);
              } else {
                onValidationChange(false);
              }
            }
            
          }), [
          inputState,
          onValidationChange
        ]);
    var tmp;
    if (typeof inputState !== "object") {
      tmp = null;
    } else {
      var error = inputState._0;
      tmp = JsxRuntime.jsx(FormV5.$$Error.make, {
            children: typeof error === "object" ? "Please use one of the cards shown above" : (
                error === "IncompleteCardNumber" ? "Enter a 16-digit number" : (
                    error === "IncompleteExpiry" ? "Enter a complete expiration date" : (
                        error === "InvalidExpiry" || error === "InvalidExpiryYear" ? "Enter a valid expiration date" : (
                            error === "InvalidCardNumber" ? "Enter a valid credit card number" : (
                                error === "IncompleteCVC" ? "Enter a valid security code" : (
                                    error === "Unknown" ? "Uknown problem" : "This expiration date has passed"
                                  )
                              )
                          )
                      )
                  )
              )
          });
    }
    return JsxRuntime.jsxs(JsxRuntime.Fragment, {
                children: [
                  labelText !== undefined ? JsxRuntime.jsx(View__Jsx3.View.make, {
                          mb: "sm",
                          children: Caml_option.some(JsxRuntime.jsx(Form__Label.make, {
                                    labelText: labelText,
                                    optionalText: props.optionalText
                                  }))
                        }) : null,
                  JsxRuntime.jsx("div", {
                        children: JsxRuntime.jsx(StripeElement.make, {
                              onFocus: (function () {
                                  dispatch({
                                        TAG: "SetFocused",
                                        _0: true
                                      });
                                }),
                              onBlur: (function () {
                                  dispatch({
                                        TAG: "SetFocused",
                                        _0: false
                                      });
                                }),
                              onChange: (function (changeObject) {
                                  var match = changeObject.complete;
                                  var inputState;
                                  if (match) {
                                    if (changeObject.cardElementType === "cardNumber") {
                                      var brand = changeObject.brand;
                                      if (brand !== undefined) {
                                        switch (brand) {
                                          case "amex" :
                                          case "discover" :
                                          case "mastercard" :
                                          case "visa" :
                                              inputState = "Complete";
                                              break;
                                          default:
                                            inputState = {
                                              TAG: "Error",
                                              _0: {
                                                NAME: "UnsupportedCard",
                                                VAL: brand
                                              }
                                            };
                                        }
                                      } else {
                                        inputState = {
                                          TAG: "Error",
                                          _0: {
                                            NAME: "UnsupportedCard",
                                            VAL: "unknown"
                                          }
                                        };
                                      }
                                    } else {
                                      inputState = "Complete";
                                    }
                                  } else if (changeObject.empty) {
                                    inputState = "Empty";
                                  } else {
                                    var error = Core__Option.map(Caml_option.nullable_to_opt(changeObject.error), (function (error) {
                                            return error.code;
                                          }));
                                    if (error !== undefined) {
                                      var e = stripeErrorFromJs(error);
                                      inputState = e !== undefined ? ({
                                            TAG: "Error",
                                            _0: e
                                          }) : ({
                                            TAG: "Error",
                                            _0: "Unknown"
                                          });
                                    } else {
                                      inputState = "InProgress";
                                    }
                                  }
                                  dispatch({
                                        TAG: "SetInputState",
                                        _0: inputState
                                      });
                                }),
                              style: Caml_option.some(elementsStyle),
                              placeholder: props.placeholder
                            }),
                        style: wrapperStyle(match$1.focused, inputState)
                      }),
                  tmp
                ]
              });
  };
  return {
          stripeErrorFromJs: stripeErrorFromJs,
          elementsStyle: elementsStyle,
          wrapperStyle: wrapperStyle,
          make: Stripe__Components$MakeStripeElement
        };
}

var StripeElement = {
  make: ReactStripeJs.CardNumberElement
};

function stripeErrorFromJs(s) {
  switch (s) {
    case "incomplete_cvc" :
        return "IncompleteCVC";
    case "incomplete_expiry" :
        return "IncompleteExpiry";
    case "incomplete_number" :
        return "IncompleteCardNumber";
    case "invalid_expiry_month_past" :
        return "ExpiryMonthPast";
    case "invalid_expiry_year" :
        return "InvalidExpiryYear";
    case "invalid_expiry_year_past" :
        return "ExpiryYearPast";
    case "invalid_number" :
        return "InvalidCardNumber";
    default:
      return ;
  }
}

var elementsStyle = {
  base: {
    fontSize: "14px",
    fontWeight: "400",
    color: Colors.black
  },
  complete: {
    color: Colors.black
  },
  invalid: {
    color: Colors.black
  }
};

function wrapperStyle(focused, inputState) {
  var tmp;
  if (focused) {
    tmp = Colors.goldTips;
  } else if (typeof inputState !== "object") {
    switch (inputState) {
      case "Empty" :
      case "InProgress" :
          tmp = Colors.alto;
          break;
      case "Complete" :
          tmp = Colors.chelseaCucumber;
          break;
      
    }
  } else {
    tmp = Colors.crimson;
  }
  return {
          borderColor: tmp,
          borderStyle: "solid",
          borderWidth: "1px",
          padding: "10px 14px",
          transition: "150ms"
        };
}

function Stripe__Components$MakeStripeElement(props) {
  var onValidationChange = props.onValidationChange;
  var labelText = props.labelText;
  var match = React.useReducer((function (state, action) {
          if (action.TAG === "SetInputState") {
            return {
                    inputState: action._0,
                    focused: state.focused
                  };
          } else {
            return {
                    inputState: state.inputState,
                    focused: action._0
                  };
          }
        }), {
        inputState: "Empty",
        focused: false
      });
  var dispatch = match[1];
  var match$1 = match[0];
  var inputState = match$1.inputState;
  React.useEffect((function () {
          if (onValidationChange !== undefined) {
            if (typeof inputState !== "object" && inputState === "Complete") {
              onValidationChange(true);
            } else {
              onValidationChange(false);
            }
          }
          
        }), [
        inputState,
        onValidationChange
      ]);
  var tmp;
  if (typeof inputState !== "object") {
    tmp = null;
  } else {
    var error = inputState._0;
    tmp = JsxRuntime.jsx(FormV5.$$Error.make, {
          children: typeof error === "object" ? "Please use one of the cards shown above" : (
              error === "IncompleteCardNumber" ? "Enter a 16-digit number" : (
                  error === "IncompleteExpiry" ? "Enter a complete expiration date" : (
                      error === "InvalidExpiry" || error === "InvalidExpiryYear" ? "Enter a valid expiration date" : (
                          error === "InvalidCardNumber" ? "Enter a valid credit card number" : (
                              error === "IncompleteCVC" ? "Enter a valid security code" : (
                                  error === "Unknown" ? "Uknown problem" : "This expiration date has passed"
                                )
                            )
                        )
                    )
                )
            )
        });
  }
  return JsxRuntime.jsxs(JsxRuntime.Fragment, {
              children: [
                labelText !== undefined ? JsxRuntime.jsx(View__Jsx3.View.make, {
                        mb: "sm",
                        children: Caml_option.some(JsxRuntime.jsx(Form__Label.make, {
                                  labelText: labelText,
                                  optionalText: props.optionalText
                                }))
                      }) : null,
                JsxRuntime.jsx("div", {
                      children: JsxRuntime.jsx(StripeElement.make, {
                            onFocus: (function () {
                                dispatch({
                                      TAG: "SetFocused",
                                      _0: true
                                    });
                              }),
                            onBlur: (function () {
                                dispatch({
                                      TAG: "SetFocused",
                                      _0: false
                                    });
                              }),
                            onChange: (function (changeObject) {
                                var match = changeObject.complete;
                                var inputState;
                                if (match) {
                                  if (changeObject.cardElementType === "cardNumber") {
                                    var brand = changeObject.brand;
                                    if (brand !== undefined) {
                                      switch (brand) {
                                        case "amex" :
                                        case "discover" :
                                        case "mastercard" :
                                        case "visa" :
                                            inputState = "Complete";
                                            break;
                                        default:
                                          inputState = {
                                            TAG: "Error",
                                            _0: {
                                              NAME: "UnsupportedCard",
                                              VAL: brand
                                            }
                                          };
                                      }
                                    } else {
                                      inputState = {
                                        TAG: "Error",
                                        _0: {
                                          NAME: "UnsupportedCard",
                                          VAL: "unknown"
                                        }
                                      };
                                    }
                                  } else {
                                    inputState = "Complete";
                                  }
                                } else if (changeObject.empty) {
                                  inputState = "Empty";
                                } else {
                                  var error = Core__Option.map(Caml_option.nullable_to_opt(changeObject.error), (function (error) {
                                          return error.code;
                                        }));
                                  if (error !== undefined) {
                                    var e = stripeErrorFromJs(error);
                                    inputState = e !== undefined ? ({
                                          TAG: "Error",
                                          _0: e
                                        }) : ({
                                          TAG: "Error",
                                          _0: "Unknown"
                                        });
                                  } else {
                                    inputState = "InProgress";
                                  }
                                }
                                dispatch({
                                      TAG: "SetInputState",
                                      _0: inputState
                                    });
                              }),
                            style: Caml_option.some(elementsStyle),
                            placeholder: props.placeholder
                          }),
                      style: wrapperStyle(match$1.focused, inputState)
                    }),
                tmp
              ]
            });
}

var CardNumberElement = {
  stripeErrorFromJs: stripeErrorFromJs,
  elementsStyle: elementsStyle,
  wrapperStyle: wrapperStyle,
  make: Stripe__Components$MakeStripeElement
};

var StripeElement$1 = {
  make: ReactStripeJs.CardExpiryElement
};

function stripeErrorFromJs$1(s) {
  switch (s) {
    case "incomplete_cvc" :
        return "IncompleteCVC";
    case "incomplete_expiry" :
        return "IncompleteExpiry";
    case "incomplete_number" :
        return "IncompleteCardNumber";
    case "invalid_expiry_month_past" :
        return "ExpiryMonthPast";
    case "invalid_expiry_year" :
        return "InvalidExpiryYear";
    case "invalid_expiry_year_past" :
        return "ExpiryYearPast";
    case "invalid_number" :
        return "InvalidCardNumber";
    default:
      return ;
  }
}

var elementsStyle$1 = {
  base: {
    fontSize: "14px",
    fontWeight: "400",
    color: Colors.black
  },
  complete: {
    color: Colors.black
  },
  invalid: {
    color: Colors.black
  }
};

function wrapperStyle$1(focused, inputState) {
  var tmp;
  if (focused) {
    tmp = Colors.goldTips;
  } else if (typeof inputState !== "object") {
    switch (inputState) {
      case "Empty" :
      case "InProgress" :
          tmp = Colors.alto;
          break;
      case "Complete" :
          tmp = Colors.chelseaCucumber;
          break;
      
    }
  } else {
    tmp = Colors.crimson;
  }
  return {
          borderColor: tmp,
          borderStyle: "solid",
          borderWidth: "1px",
          padding: "10px 14px",
          transition: "150ms"
        };
}

function Stripe__Components$MakeStripeElement$1(props) {
  var onValidationChange = props.onValidationChange;
  var labelText = props.labelText;
  var match = React.useReducer((function (state, action) {
          if (action.TAG === "SetInputState") {
            return {
                    inputState: action._0,
                    focused: state.focused
                  };
          } else {
            return {
                    inputState: state.inputState,
                    focused: action._0
                  };
          }
        }), {
        inputState: "Empty",
        focused: false
      });
  var dispatch = match[1];
  var match$1 = match[0];
  var inputState = match$1.inputState;
  React.useEffect((function () {
          if (onValidationChange !== undefined) {
            if (typeof inputState !== "object" && inputState === "Complete") {
              onValidationChange(true);
            } else {
              onValidationChange(false);
            }
          }
          
        }), [
        inputState,
        onValidationChange
      ]);
  var tmp;
  if (typeof inputState !== "object") {
    tmp = null;
  } else {
    var error = inputState._0;
    tmp = JsxRuntime.jsx(FormV5.$$Error.make, {
          children: typeof error === "object" ? "Please use one of the cards shown above" : (
              error === "IncompleteCardNumber" ? "Enter a 16-digit number" : (
                  error === "IncompleteExpiry" ? "Enter a complete expiration date" : (
                      error === "InvalidExpiry" || error === "InvalidExpiryYear" ? "Enter a valid expiration date" : (
                          error === "InvalidCardNumber" ? "Enter a valid credit card number" : (
                              error === "IncompleteCVC" ? "Enter a valid security code" : (
                                  error === "Unknown" ? "Uknown problem" : "This expiration date has passed"
                                )
                            )
                        )
                    )
                )
            )
        });
  }
  return JsxRuntime.jsxs(JsxRuntime.Fragment, {
              children: [
                labelText !== undefined ? JsxRuntime.jsx(View__Jsx3.View.make, {
                        mb: "sm",
                        children: Caml_option.some(JsxRuntime.jsx(Form__Label.make, {
                                  labelText: labelText,
                                  optionalText: props.optionalText
                                }))
                      }) : null,
                JsxRuntime.jsx("div", {
                      children: JsxRuntime.jsx(StripeElement$1.make, {
                            onFocus: (function () {
                                dispatch({
                                      TAG: "SetFocused",
                                      _0: true
                                    });
                              }),
                            onBlur: (function () {
                                dispatch({
                                      TAG: "SetFocused",
                                      _0: false
                                    });
                              }),
                            onChange: (function (changeObject) {
                                var match = changeObject.complete;
                                var inputState;
                                if (match) {
                                  if (changeObject.cardElementType === "cardNumber") {
                                    var brand = changeObject.brand;
                                    if (brand !== undefined) {
                                      switch (brand) {
                                        case "amex" :
                                        case "discover" :
                                        case "mastercard" :
                                        case "visa" :
                                            inputState = "Complete";
                                            break;
                                        default:
                                          inputState = {
                                            TAG: "Error",
                                            _0: {
                                              NAME: "UnsupportedCard",
                                              VAL: brand
                                            }
                                          };
                                      }
                                    } else {
                                      inputState = {
                                        TAG: "Error",
                                        _0: {
                                          NAME: "UnsupportedCard",
                                          VAL: "unknown"
                                        }
                                      };
                                    }
                                  } else {
                                    inputState = "Complete";
                                  }
                                } else if (changeObject.empty) {
                                  inputState = "Empty";
                                } else {
                                  var error = Core__Option.map(Caml_option.nullable_to_opt(changeObject.error), (function (error) {
                                          return error.code;
                                        }));
                                  if (error !== undefined) {
                                    var e = stripeErrorFromJs$1(error);
                                    inputState = e !== undefined ? ({
                                          TAG: "Error",
                                          _0: e
                                        }) : ({
                                          TAG: "Error",
                                          _0: "Unknown"
                                        });
                                  } else {
                                    inputState = "InProgress";
                                  }
                                }
                                dispatch({
                                      TAG: "SetInputState",
                                      _0: inputState
                                    });
                              }),
                            style: Caml_option.some(elementsStyle$1),
                            placeholder: props.placeholder
                          }),
                      style: wrapperStyle$1(match$1.focused, inputState)
                    }),
                tmp
              ]
            });
}

var CardExpiryElement = {
  stripeErrorFromJs: stripeErrorFromJs$1,
  elementsStyle: elementsStyle$1,
  wrapperStyle: wrapperStyle$1,
  make: Stripe__Components$MakeStripeElement$1
};

var StripeElement$2 = {
  make: ReactStripeJs.CardCvcElement
};

function stripeErrorFromJs$2(s) {
  switch (s) {
    case "incomplete_cvc" :
        return "IncompleteCVC";
    case "incomplete_expiry" :
        return "IncompleteExpiry";
    case "incomplete_number" :
        return "IncompleteCardNumber";
    case "invalid_expiry_month_past" :
        return "ExpiryMonthPast";
    case "invalid_expiry_year" :
        return "InvalidExpiryYear";
    case "invalid_expiry_year_past" :
        return "ExpiryYearPast";
    case "invalid_number" :
        return "InvalidCardNumber";
    default:
      return ;
  }
}

var elementsStyle$2 = {
  base: {
    fontSize: "14px",
    fontWeight: "400",
    color: Colors.black
  },
  complete: {
    color: Colors.black
  },
  invalid: {
    color: Colors.black
  }
};

function wrapperStyle$2(focused, inputState) {
  var tmp;
  if (focused) {
    tmp = Colors.goldTips;
  } else if (typeof inputState !== "object") {
    switch (inputState) {
      case "Empty" :
      case "InProgress" :
          tmp = Colors.alto;
          break;
      case "Complete" :
          tmp = Colors.chelseaCucumber;
          break;
      
    }
  } else {
    tmp = Colors.crimson;
  }
  return {
          borderColor: tmp,
          borderStyle: "solid",
          borderWidth: "1px",
          padding: "10px 14px",
          transition: "150ms"
        };
}

function Stripe__Components$MakeStripeElement$2(props) {
  var onValidationChange = props.onValidationChange;
  var labelText = props.labelText;
  var match = React.useReducer((function (state, action) {
          if (action.TAG === "SetInputState") {
            return {
                    inputState: action._0,
                    focused: state.focused
                  };
          } else {
            return {
                    inputState: state.inputState,
                    focused: action._0
                  };
          }
        }), {
        inputState: "Empty",
        focused: false
      });
  var dispatch = match[1];
  var match$1 = match[0];
  var inputState = match$1.inputState;
  React.useEffect((function () {
          if (onValidationChange !== undefined) {
            if (typeof inputState !== "object" && inputState === "Complete") {
              onValidationChange(true);
            } else {
              onValidationChange(false);
            }
          }
          
        }), [
        inputState,
        onValidationChange
      ]);
  var tmp;
  if (typeof inputState !== "object") {
    tmp = null;
  } else {
    var error = inputState._0;
    tmp = JsxRuntime.jsx(FormV5.$$Error.make, {
          children: typeof error === "object" ? "Please use one of the cards shown above" : (
              error === "IncompleteCardNumber" ? "Enter a 16-digit number" : (
                  error === "IncompleteExpiry" ? "Enter a complete expiration date" : (
                      error === "InvalidExpiry" || error === "InvalidExpiryYear" ? "Enter a valid expiration date" : (
                          error === "InvalidCardNumber" ? "Enter a valid credit card number" : (
                              error === "IncompleteCVC" ? "Enter a valid security code" : (
                                  error === "Unknown" ? "Uknown problem" : "This expiration date has passed"
                                )
                            )
                        )
                    )
                )
            )
        });
  }
  return JsxRuntime.jsxs(JsxRuntime.Fragment, {
              children: [
                labelText !== undefined ? JsxRuntime.jsx(View__Jsx3.View.make, {
                        mb: "sm",
                        children: Caml_option.some(JsxRuntime.jsx(Form__Label.make, {
                                  labelText: labelText,
                                  optionalText: props.optionalText
                                }))
                      }) : null,
                JsxRuntime.jsx("div", {
                      children: JsxRuntime.jsx(StripeElement$2.make, {
                            onFocus: (function () {
                                dispatch({
                                      TAG: "SetFocused",
                                      _0: true
                                    });
                              }),
                            onBlur: (function () {
                                dispatch({
                                      TAG: "SetFocused",
                                      _0: false
                                    });
                              }),
                            onChange: (function (changeObject) {
                                var match = changeObject.complete;
                                var inputState;
                                if (match) {
                                  if (changeObject.cardElementType === "cardNumber") {
                                    var brand = changeObject.brand;
                                    if (brand !== undefined) {
                                      switch (brand) {
                                        case "amex" :
                                        case "discover" :
                                        case "mastercard" :
                                        case "visa" :
                                            inputState = "Complete";
                                            break;
                                        default:
                                          inputState = {
                                            TAG: "Error",
                                            _0: {
                                              NAME: "UnsupportedCard",
                                              VAL: brand
                                            }
                                          };
                                      }
                                    } else {
                                      inputState = {
                                        TAG: "Error",
                                        _0: {
                                          NAME: "UnsupportedCard",
                                          VAL: "unknown"
                                        }
                                      };
                                    }
                                  } else {
                                    inputState = "Complete";
                                  }
                                } else if (changeObject.empty) {
                                  inputState = "Empty";
                                } else {
                                  var error = Core__Option.map(Caml_option.nullable_to_opt(changeObject.error), (function (error) {
                                          return error.code;
                                        }));
                                  if (error !== undefined) {
                                    var e = stripeErrorFromJs$2(error);
                                    inputState = e !== undefined ? ({
                                          TAG: "Error",
                                          _0: e
                                        }) : ({
                                          TAG: "Error",
                                          _0: "Unknown"
                                        });
                                  } else {
                                    inputState = "InProgress";
                                  }
                                }
                                dispatch({
                                      TAG: "SetInputState",
                                      _0: inputState
                                    });
                              }),
                            style: Caml_option.some(elementsStyle$2),
                            placeholder: props.placeholder
                          }),
                      style: wrapperStyle$2(match$1.focused, inputState)
                    }),
                tmp
              ]
            });
}

var CardCVCElement = {
  stripeErrorFromJs: stripeErrorFromJs$2,
  elementsStyle: elementsStyle$2,
  wrapperStyle: wrapperStyle$2,
  make: Stripe__Components$MakeStripeElement$2
};

var Form;

var View;

exports.Form = Form;
exports.View = View;
exports.MakeStripeElement = MakeStripeElement;
exports.CardNumberElement = CardNumberElement;
exports.CardExpiryElement = CardExpiryElement;
exports.CardCVCElement = CardCVCElement;
/* StripeElement Not a pure module */
